import { Container } from 'inversify';
import { BootstrapService } from './bootstrap.service';
import { BrowserStorageService } from './browserStorage.service';

export const browserContainer = new Container();

browserContainer.bind<BootstrapService>(BootstrapService).toSelf().inSingletonScope();
browserContainer.bind<BrowserStorageService>(BrowserStorageService).toSelf().inSingletonScope();
